import React, { Component } from 'react'
import { I18n } from 'galarm-config'
import { Constants } from 'galarm-config'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { AlarmUtils } from 'galarm-shared'
import { Box, Text, TextInput } from 'grommet'
import DaysOfWeekPicker from './DaysOfWeekPicker'
import { SecondaryText } from 'web-components'

class SelectWeeksRepetition extends Component {
  static defaultProps = {
    repeat: '2'
  }

  getDayFromAlarmDate = () => {
    if (!this.props.alarmDate) {
      return this.getCurrentDayAsRepeatDay()
    }

    const alarmDate = new Date(this.props.alarmDate)
    const dayOfWeek = alarmDate.getDay() // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

    return Constants.RepeatAllDays[dayOfWeek]
  }

  getCurrentDayAsRepeatDay = () => {
    const today = new Date()
    const dayOfWeek = today.getDay() // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

    return Constants.RepeatAllDays[dayOfWeek]
  }

  getDefaultSelectedDays = () => {
    const { selectedDays } = AlarmUtils.getRepeatOptionsForWeeksRepetition(
      this.props.repeat
    )

    // For new alarms (default repeat value '2' with no selected days) or existing alarms with no days,
    // default to the alarm date's day (or current day if no alarm date)
    const isNewAlarmOrNoDays = !selectedDays || selectedDays.length === 0

    return {
      selectedDays: isNewAlarmOrNoDays
        ? [this.getDayFromAlarmDate()]
        : selectedDays
    }
  }

  getDefaultWeeks = () => {
    const { weeks } = AlarmUtils.getRepeatOptionsForWeeksRepetition(
      this.props.repeat
    )
    return weeks || '2'
  }

  state = {
    weeks: this.getDefaultWeeks(),
    selectedDays: this.getDefaultSelectedDays().selectedDays
  }

  onChangeWeeks = event => {
    const newWeeksInt = parseInt(event.target.value)
    this.setState(
      {
        weeks: newWeeksInt ? newWeeksInt.toString() : ''
      },
      () => {
        if (this.state.weeks) {
          this.saveRepetition()
        }
      }
    )
  }

  onSelectDay = day => {
    let newSelectedDays = this.state.selectedDays.slice()
    if (!this.state.selectedDays.includes(day.value)) {
      newSelectedDays.push(day.value)
    } else {
      const index = this.state.selectedDays.findIndex(
        selectedDay => selectedDay === day.value
      )
      newSelectedDays.splice(index, 1)
    }

    this.setState(
      {
        selectedDays: newSelectedDays
      },
      () => {
        if (this.state.selectedDays.length > 0) {
          this.saveRepetition()
        }
      }
    )
  }

  getSortedSelectedDays = newSelectedDays => {
    const sortedSelectedDays = []
    Object.keys(Constants.RepeatDayToDayMapping).forEach(repeatDay => {
      if (
        newSelectedDays.findIndex(selectedDay => selectedDay === repeatDay) !==
        -1
      ) {
        sortedSelectedDays.push(repeatDay)
      }
    })
    const selectedDaysString = sortedSelectedDays.join(',')
    return selectedDaysString
  }

  saveRepetition = () => {
    if (this.state.weeks && this.state.selectedDays.length > 0) {
      // Create repeat string with format "weeks:days" (e.g., "2:every_mon,every_tue")
      const selectedDaysString = this.getSortedSelectedDays(
        this.state.selectedDays
      )
      const repeatString = `${this.state.weeks}:${selectedDaysString}`

      this.props.onSaveAlarmRepetition(
        Constants.RepeatTypes.WEEKS,
        repeatString
      )
    }
  }

  renderHelperTextComponent = daysString => {
    const hasWeeks = !isEmpty(this.state.weeks)
    const hasDays = this.state.selectedDays.length > 0

    return (
      <Box pad="small">
        {hasWeeks && hasDays ? (
          <SecondaryText>
            {I18n.t(
              this.state.selectedDays.length === 7
                ? 'weeksRepetitionPreviewStringEveryDay'
                : 'weeksRepetitionPreviewString',
              {
                daysString:
                  this.state.selectedDays.length === 7
                    ? I18n.t('everyDay')
                    : daysString,
                weeks: this.state.weeks || '1',
                count: parseInt(this.state.weeks || '1')
              }
            )}
          </SecondaryText>
        ) : (
          <SecondaryText>
            {I18n.t('specifyNumberOfWeeksAndChooseDays')}
          </SecondaryText>
        )}
      </Box>
    )
  }

  render() {
    const baseDaysString = AlarmUtils.createSelectedDaysString(
      this.state.selectedDays
    )

    return (
      <Box width="450px" direction="column">
        <Box
          direction="row"
          pad="small"
          justify="between"
          align="center"
          background="listItemSelectedColor">
          <Box>
            <Box direction="row" align="center">
              <Text>{I18n.t('repeatEvery')}</Text>
              <Box pad={{ horizontal: 'small' }} width="80px">
                <TextInput
                  size="medium"
                  value={this.state.weeks}
                  onChange={this.onChangeWeeks}
                  margin="small"
                />
              </Box>
              <Text margin={{ right: '20px' }}>
                {I18n.t('repeatEveryWeeks')}
              </Text>
            </Box>
            <DaysOfWeekPicker
              selectedDays={this.state.selectedDays}
              onSelectDay={this.onSelectDay}
            />
            {this.renderHelperTextComponent(baseDaysString)}
          </Box>
        </Box>
      </Box>
    )
  }
}

const mapStateToProps = state => ({
  colorScheme: state.userSettings.webColorScheme
})

export default connect(mapStateToProps)(SelectWeeksRepetition)
